import { __assign } from "tslib";
import * as React from 'react';
import { NamespacesConsumer, } from 'react-i18next';
import { ConfigContextConsumer } from '../config-context';
export var withTranslation = function (component) {
    return function (props) { return (React.createElement(ConfigContextConsumer, null, function (_a) {
        var i18nConfig = _a.i18n;
        var i18n = i18nConfig || props.i18n;
        if (i18n) {
            return React.createElement(component, __assign(__assign({}, props), { t: function (k, o) { return i18n.t(k, o); } }));
        }
        return (React.createElement(NamespacesConsumer, null, function (t) { return React.createElement(component, __assign(__assign({}, props), { t: t })); }));
    })); };
};
//# sourceMappingURL=with-translation.js.map